import { render, staticRenderFns } from "./SideBar2.vue?vue&type=template&id=257030c3&scoped=true"
import script from "./SideBar2.vue?vue&type=script&lang=js"
export * from "./SideBar2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257030c3",
  null
  
)

export default component.exports